import { GridReadyEvent, RowNode } from "ag-grid-community";
import { useCallback, useRef } from "react";
import { BaseAgGrid } from "../grid/BaseAgGrid";
import useNLGridDashboard from "./useNLGridDashboard";
import { ManagerStat } from "src/app/types/orders/order";

export interface ISiteGridDashboard {
    siteHasManagerNetlinkingStats?: Array<ManagerStat>;
}

const NLGridDashboard = (props: ISiteGridDashboard) => {
    const { siteHasManagerNetlinkingStats = [] } = props;

    const gridColumns = useNLGridDashboard();
    const gridRef = useRef(null);

    const doesExternalFilterPass = useCallback((node: RowNode): boolean => {
        if (node.data) {
            return !!node.data;
        }
        return true;
    }, []);
    const onGridReady = useCallback((params: GridReadyEvent) => {
        const gridApi = params.api;
        gridApi.sizeColumnsToFit();
    }, []);

    return (
        <div className="ag-theme-balham" style={{ height: "100%" }}>
            <BaseAgGrid
                listHandler={() => {}}
                asCellFilter={false}
                sideBar={null}
                gridRef={gridRef}
                rowData={siteHasManagerNetlinkingStats}
                columnDefs={gridColumns}
                isExternalFilterPresent={() => true}
                onModelUpdated={() => {}}
                onGridReady={onGridReady}
                doesExternalFilterPass={doesExternalFilterPass}
            />
        </div>
    );
};

export default NLGridDashboard;
